import React from 'react'

import clsx from 'clsx'

import Button from 'components/Button'
import Icon from 'components/Icon'
import Typography from 'components/Typography'

import classes from './FilterToggle.module.scss'

const noop = () => {}

/** @type {import("./types").default} */
const FilterToggle = ({ label = 'Filters', onClick = noop, selectedFilters }) => {
  const handleClick = event => {
    onClick(event)
  }

  return (
    <Button
      className={clsx('FilterToggle', classes.filterToggleButton, { [classes.withSelectedFilters]: selectedFilters })}
      onClick={handleClick}
      variant="contained"
    >
      {selectedFilters ? (
        <div className={classes.selectedFilters}>
          <span> {selectedFilters < 10 ? selectedFilters : '9+'}</span>
        </div>
      ) : (
        <Icon icon={['fal', 'sliders-h']} className={classes.icon} size="20" />
      )}
      <Typography variant="body-xs">{selectedFilters === 1 ? label.slice(0, -1) : label}</Typography>
    </Button>
  )
}

export default FilterToggle
